import { useParams } from 'react-router-dom';
import { useGetCompaniesByIdQuery } from '@client/api';
import { PageContentAnimation } from '../../../../components/layout';
import { CompanyProfileCard } from '../components/company-profile-card.component';
import { CompanyRentalIncomeWidget } from '../components/company-rental-income-widget';

export function CompanyProfileTab() {
  const { id } = useParams<{ id: string }>();
  const { data: company } = useGetCompaniesByIdQuery({ id: id ?? '' }, { skip: id == null });

  const isTenant = company?.roles?.includes('Tenant') ?? false;

  return (
    <PageContentAnimation>
      <div className={isTenant ? 'grid grid-cols-2 gap-4' : ''}>
        <CompanyProfileCard />
        {isTenant && id && <CompanyRentalIncomeWidget companyId={id} />}
      </div>
    </PageContentAnimation>
  );
}
